import { render } from "./RequestOtpView.vue?vue&type=template&id=6cd2cc47&scoped=true"
import script from "./RequestOtpView.vue?vue&type=script&lang=js"
export * from "./RequestOtpView.vue?vue&type=script&lang=js"

import "./RequestOtpView.vue?vue&type=style&index=0&id=6cd2cc47&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cd2cc47"]])

export default __exports__